import React from 'react';
import { Slider } from '@mui/material';

type Marks = {
  value: number;
  label: string;
};

type DiscreteSliderProps = {
  sliderValue: number | undefined;
  onSliderChange: (event: Event, newValue: number | number[]) => void;
  min: number;
  max: number;
  marks: Marks[];
};

const DiscreteSlider = ({ sliderValue, onSliderChange, min, max, marks }: DiscreteSliderProps) => {
  return (
    <Slider
      aria-label="Term Insurance"
      value={sliderValue}
      onChange={onSliderChange}
      defaultValue={1}
      valueLabelDisplay="auto"
      shiftStep={1}
      step={1}
      min={min}
      max={max}
      marks={marks}
      sx={{
        color: '#483FCD',
        '& .MuiSlider-track, & .MuiSlider-rail': {
          height: 6
        },
        '& .MuiSlider-mark, & .MuiSlider-markActive': {
          height: 4,
          width: 4,
          borderRadius: 100
        },
        '& .MuiSlider-markLabel': {
          marginLeft: '3px'
        }
      }}
    />
  );
};

export default DiscreteSlider;
